import React from "react";
import { string } from "prop-types";
import RichText from "../../atoms/RichText";
import useIsMobile from "../../../hooks/useIsMobile";

import "./content-paragraph.m.css";

const ContentParagraph = ({ content, ...props }) => {
  const isMobile = useIsMobile();

  return (
    <div styleName="content-paragraph" {...props}>
      <RichText content={content} isMobile={isMobile} />
    </div>
  );
};

ContentParagraph.propTypes = {
  content: string
};

export default ContentParagraph;